/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { Skeleton, View } from '@az/starc-ui';

export const LoadingReview = () => {
  return (
    <View className={styles.loadingStateContainer}>
      <Skeleton className={styles.rating} />
      <Skeleton className={styles.title} />
      <Skeleton className={styles.postDetails} />
      <Skeleton className={styles.content} />
      <Skeleton className={styles.images} />
      <Skeleton className={styles.purchasedFor} />
      <Skeleton className={styles.feedbackButtons} />
    </View>
  );
};
